import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.SeekAndFind;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "SeekAndFind.Phaser.IntroductionScene.1",
            "SeekAndFind.Phaser.IntroductionScene.2",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/SeekAndFindGame/scenes/GameIntro.ts